<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-27 15:51:58
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-20 15:06:19
-->
<template>
  <keep-alive>
    <router-view :key="key" />
  </keep-alive>
</template>

<script>
import { setRem } from '@utils'
export default {
  name: 'FiveBigscreen',
  computed: {
    key() {
      return this.$route.fullPath
    }
  },
  mounted() {
    setRem()
    window.onresize = () => {
      setRem()
    }
  },
  beforeDestroy() {
    // 离开运行监测-恢复根元素font-size大小 清空yxjcCurrentMenu
    setRem(14)
    window.onresize = null
  }
}
</script>

<style lang="less"></style>
